import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { HelperService } from 'src/services/helperService';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-adapter';
import { CUSTOM_DATE_FORMATS } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-formats';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';
import { CustomerVehicleData } from 'src/services/api-services/api-interfaces/customerVehicleData.interface';
import { AppointmentExtended } from 'src/services/incadea/incadea-interfaces/AppointmentExtended.interface';
import { AppointmentComponent } from '../newAppointment/appointment.component';
import { tap } from 'rxjs';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { TranslateService } from '@ngx-translate/core';

import moment from 'moment';


@Component({
    selector: 'app-find-client-info',
    templateUrl: './find-client-info.dialog.html',
    styleUrls: ['../../../../scheduling/dialogs/search-plate/search-plate.dialog.sass'],
    providers: [
        TitleCasePipe,
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    ],
    standalone: false
})
export class FindClientInfoDialog implements OnInit{
  startDate = new Date(this.appointment.start);
  endDate = new Date(this.appointment.end);
  plateNumber: string = ''
  formattedStartDate = this.startDate.toLocaleDateString(this.helperService.user.language, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });

  appointmentSchedule: string = ''
  showError: boolean= false
  isLoading: boolean= false
  constructor(
    public titleCasePipe: TitleCasePipe,
    public helperService: HelperService,
    public vehicleDataService: VehicleDataService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FindClientInfoDialog>,
    public customerBasicDataService: APICustomerBasicDataService,
    private translate: TranslateService,

    @Inject(MAT_DIALOG_DATA) public appointment: AppointmentExtended,

    ) { }

  ngOnInit(): void {
    this.appointmentSchedule = this.titleCasePipe.transform(`${this.formattedStartDate}`);
  }

  toUpperPlateNumber(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }

  onSearch(){
    this.isLoading=true
    this.showError = false

   const searchByPlateSubscribe= this.vehicleDataService?.getValidatedData(this.plateNumber).pipe(tap(( customer )=> {
      if (customer === null) {
        this.showError = true
        this.isLoading = false

      } else{
        const customerVehicleData:CustomerVehicleData = customer[0]

        if (!customer[0].message) {
          const { selectedLocation, selectedDepartment, selectedMake,selectedService, selectedResource,selectedCompany, start, end, token} = this.appointment;
          const dialogData = {
            customerVehicleData,
            completeDate: this.appointmentSchedule,
            selectedLocation,
            selectedDepartment,
            selectedMake,
            selectedService,
            selectedResource,
            selectedCompany,
            start,
            end,
            token
        };

        this.isLoading= false

        const dialogAppointment = this.dialog.open(AppointmentComponent,{
          width: '903px',
          panelClass: "icon-outside",
          data: dialogData
        })
        dialogAppointment.afterClosed().subscribe((result)=>{
          if (result) {
            this.dialogRef.close(true);
          }})
        }
      }
    })).subscribe({
      error: (error) => {
        // Manejo de error 401
        if (error.status === 401) {
          this.helperService.logoutToken();
        }

        const translateTxtNotMatch = this.translate.instant("notMatchFound")

        this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =translateTxtNotMatch
        setTimeout(() => {
          this.helperService.showAlert =false
          }, 7000)
      }
    });

  }
  onAddCustomer(){
    const { selectedLocation, selectedDepartment, selectedMake,selectedService, selectedResource,selectedCompany, start, end, token} = this.appointment;
    const data ={
      completeDate: this.appointmentSchedule,
        selectedLocation,
        selectedDepartment,
        selectedMake,
        selectedService,
        selectedResource,
        selectedCompany,
        start,
        end,
        token
      }
      const dialogAppointment = this.dialog.open(AppointmentComponent,{
      width: '903px',
      panelClass: "icon-outside",
      data
    })
    dialogAppointment.afterClosed().subscribe((result)=>{
      if (result) {
        this.dialogRef.close(true);
      }})
  }

}
